<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div class="ufv-container-text">
            <div class="text-h4">Área Administrativa: Contextos</div>
        </div>
        <div
            v-if="loading"
            class="my-8 align-self-stretch d-flex align-center justify-center"
        >
            <spinner />
        </div>
        <div
            v-if="!loading"
            class="my-6 flex-grow-1"
            style="border: 0px solid red"
        >
            <div style="border: 0px solid red" class="mt-4">
                <v-simple-table dense fixed-header>
                    <thead>
                        <tr>
                            <th class="text-center">Sigla</th>
                            <th>Contexto</th>
                            <th class="text-center">Habilitado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="contexto in contextos" :key="contexto.id">
                            <td class="text-center">
                                <router-link
                                    :to="{
                                        name: 'ContextoAdmin',
                                        params: { id: contexto.id },
                                    }"
                                >
                                    {{ contexto.sigla }}
                                </router-link>
                            </td>
                            <td>{{ contexto.nome }}</td>
                            <td class="text-center">
                                <v-icon v-if="contexto.habilitada"
                                    >mdi-rocket-launch</v-icon
                                >
                                <v-icon v-if="!contexto.habilitada"
                                    >mdi-pause-circle</v-icon
                                >
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
        </div>
    </v-container>
</template>

<script>
import { getServicoContexto } from "../../../services/ServicosFactory";
import Spinner from "../../../componentes/ui/Spinner";

const servicoContexto = getServicoContexto();

export default {
    data() {
        return {
            loading: true,
            contextos: [],
        };
    },
    components: { Spinner },
    mounted() {
        servicoContexto
            .obterContextos()
            .then((data) => {
                this.loading = false;
                this.contextos = data;
            })
            .catch((err) => {
                console.log(err);
                this.$router.push({ name: "500" });
            });
    },
};
</script>
